import { client } from "utils/api";

const getPlatformTaxonByExternalId = async ({ external_id, platform_id }) => {
  try {
    const { data } = await client.get(
      `/platform_taxons?context=list&q[platform_id_eq]=${platform_id}&q[external_id_eq]=${external_id}`
    );
    if (data.length === 1) {
      return data[0];
    } else {
      throw new Error(`Nie znaleziono kategorii o id - ${external_id}`);
    }
  } catch (error) {
    throw error;
  }
};

export default getPlatformTaxonByExternalId;
